import { useMemo, useState, useContext } from "react";
import Select from 'react-select';
import { GlobalStateContext } from "../../context/GlobalStateContext";

import styles from "./FiltersComponents.module.css";

export const FilterDropdown = ({options, single_item, plural_items, filterType}) => {
    const { updateFilters } = useContext(GlobalStateContext);
    const [value, setValue] = useState([]);

    function capitalizeFirst(str) {
        if (typeof str !== 'string') return '';
        if (str.length === 0) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const placeholders = useMemo(() => {
        const count = value.length;
        return count === 0 ? `${capitalizeFirst(plural_items)}` : `${count} ${count > 1 ? plural_items : single_item}`;
    }, [value]);
    const SURFACE = "rgba(15, 23, 42, 0.9)";
    const BORDER = "rgba(148, 163, 184, 0.20)";
    const TEXT = "#e5e7eb";
    const MUTED = "rgba(226, 232, 240, 0.75)";
    const OPTION_SIZE = 13;

    const colourStyles = {
    container: (base) => ({
        ...base,
    }),

    control: (base, state) => ({
        ...base,
        minHeight: 46,
        borderRadius: 999,
        backgroundColor: "rgba(67, 186, 101, 0.16)",  // tinted pill
        border: `1px solid ${state.isFocused ? "rgba(67,186,101,0.65)" : BORDER}`,
        boxShadow: state.isFocused ? "0 0 0 4px rgba(67, 186, 101, 0.18)" : "0 6px 18px rgba(0,0,0,0.18)",
        transition: "all 150ms ease",
        cursor: "pointer",
        paddingLeft: 8,
        paddingRight: 6,
        ":hover": {
            borderColor: "rgba(67,186,101,0.55)",
            backgroundColor: "rgba(67, 186, 101, 0.22)",
        },
    }),

    valueContainer: (base) => ({
        ...base,
        padding: "0 8px",
    }),

    placeholder: (base) => ({
        ...base,
        color: TEXT,
        fontWeight: 600,
        letterSpacing: "0.2px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    }),

    singleValue: (base) => ({
        ...base,
        color: TEXT,
    }),

    indicatorsContainer: (base) => ({
        ...base,
    }),

    dropdownIndicator: (base, state) => ({
        ...base,
        color: MUTED,
        transition: "transform 150ms ease, color 150ms ease",
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
        ":hover": { color: TEXT },
    }),

    clearIndicator: (base) => ({
        ...base,
        color: MUTED,
        ":hover": { color: TEXT },
    }),

    indicatorSeparator: () => ({
        display: "none",
    }),

    menu: (base) => ({
        ...base,
        borderRadius: 14,
        overflow: "hidden",
        backgroundColor: SURFACE,
        border: `1px solid ${BORDER}`,
        boxShadow: "0 18px 40px rgba(0,0,0,0.35)",
        backdropFilter: "blur(10px)",
    }),

    menuList: (base) => ({
        ...base,
        padding: 6,
        maxHeight: 260,
        overflowX: "hidden",
    }),

    option: (base, state) => ({
        ...base,
        borderRadius: 10,
        margin: "4px 2px",
        padding: "10px 12px",
        width: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        fontSize: OPTION_SIZE,
        backgroundColor: state.isSelected
            ? "rgba(67, 186, 101, 0.22)"
            : state.isFocused
            ? "rgba(148, 163, 184, 0.12)"
            : "transparent",
        color: TEXT,
        cursor: state.isDisabled ? "not-allowed" : "pointer",
        transition: "background-color 120ms ease",
        ":active": {
            backgroundColor: "rgba(67, 186, 101, 0.28)",
        },
    }),

    multiValue: (base) => ({
        ...base,
        backgroundColor: "rgba(67, 186, 101, 0.22)",
        border: "1px solid rgba(67, 186, 101, 0.35)",
        borderRadius: 999,
    }),

    multiValueLabel: (base) => ({
        ...base,
        color: TEXT,
        fontWeight: 600,
        padding: "3px 8px",
    }),

    multiValueRemove: (base) => ({
        ...base,
        color: MUTED,
        borderRadius: 999,
        ":hover": {
            backgroundColor: "rgba(239, 68, 68, 0.18)",
            color: "#fecaca",
        },
    }),
    };

    return <Select 
        options={options.map(option => ({ value: option, label: option }))} 
        isMulti
        closeMenuOnSelect={false}
        placeholder={placeholders}
        className={styles.filterDropdown}
        controlShouldRenderValue={false}
        hideSelectedOptions={false}
        value={value}
        onChange={(v) => {
            setValue(v || []);
            // Update global state or perform filtering based on filterType
            const selectedValues = (v || []).map(item => item.value);
            updateFilters({ [filterType]: selectedValues})
        }}
        backspaceRemovesValue
        styles={colourStyles}
        
    />;
};